import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';

// If You Want To Import Specific Css File use this way
// import "./arabic.css";






import TrendingNews_Ar from './TrendingNews_Ar.js';
import FeatureNews_Home_Ar from './FeatureNews_Home_Ar.js';
import Cricket_Home_Ar from './Cricket_Home_Ar.js';

import Football_MostView_Ar from './Football_MostView_Ar.js';
import Basketball_Home_Ar from './Basketball_Home_Ar.js';


import Tennis_Home_Ar from './Tennis_Home_Ar.js';

import WhatNew_Home_Ar from './WhatNew_Home_Ar.js';
import UFC_HOME_ar from './UFC_HOME_ar.js';

import Boxing_Home_Ar from './Boxing_Home_Ar.js';


export default function Arabic() {


  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();


  async function refda() {




    setNisLoading(true);



  };

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])









  return (
    <>

      <div className='backgroundcolor'>

        <section className="all-post-style-2-area">
          <div className="container custom-container">
            <div className="row">
              <div className="col-lg-8 ">
                <TrendingNews_Ar />


                <div className='float-right  '>
                  <FeatureNews_Home_Ar />
                </div>


                {/* criket */}

                <Cricket_Home_Ar />

              </div>
              <div className="col-lg-4">
                <div className="all-post-sidebar-style-2 mt-40">
                  <Football_MostView_Ar />
                  <div className="ad mt-40">
                    <a href="#"><img src="./images/ad/ad-3.png" alt="" /></a>
                  </div>
                  {/* Basket box */}
                  <Basketball_Home_Ar />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End First Section */}


        {/*Start  whats new and Videos */}
        <section className='container custom-container'>



          <div className='row'>

            <div className="col-lg-4 mt-3">
              {/* WHATS NEW  */}

              <WhatNew_Home_Ar />
            </div>


            <div className='col-lg-8 mt-3   bg-white col-sm-12'>
              {/* Tennis Section */}
              <Tennis_Home_Ar />
            </div>


          </div>
          {/* end videos section and whats new  */}

          <div className='row'>

            <div className='col-lg-4 col-sm-12'>
              <div>
                {/* ads in Opinion Section */}
                <img className=' mt-3' src="./images/ad/ad-3.png" />
              </div>
            </div>
            <div className='col-lg-4 col-sm-12'>
              {/* UFC */}
              <UFC_HOME_ar />
            </div>


            <div className='col-lg-4 col-sm-12'>
              {/* boxing */}


              <Boxing_Home_Ar />
            </div>

          </div>

          <br></br>
          <br></br>
        </section>
      </div>
    </>
  );
}



